import { useCallback, useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const useCampo = () => {
  const [campo, setCampo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const createCampo = async (data) => {
    try {
      await api.post("api/permisos/campo/create/", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("@Token"),
        },
      });
    } catch (error) {
      throw error;
    }
  };

  const updateCampo = async (campo_id, data) => {
    try {
      await api.put(`api/permisos/campo/${campo_id}/update/`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("@Token"),
        },
      });
    } catch (error) {
      throw error;
    }
  };

  const deleteCampo = async (campo_id) => {
    try {
      await api.delete(`api/permisos/campo/${campo_id}/delete/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("@Token"),
        },
      });
    } catch (error) {
      throw error;
    }
  };

  const restoreCampo = async (campo_id) => {
    try {
      await api.put(
        `api/permisos/campo/${campo_id}/restore/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + localStorage.getItem("@Token"),
          },
        },
      );
    } catch (error) {
      throw error;
    }
  };

  const fetchCampos = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`api/permisos/campo/list/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("@Token"),
        },
      });
      setCampo(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCampos();
  }, [fetchCampos]);

  return {
    campo,
    fetchCampos,
    isLoading,
    createCampo,
    updateCampo,
    deleteCampo,
    restoreCampo,
  };
};
